<template>
    <div>
        <div class="grid grid-cols-1 gap-2 pt-4 pb-16 grid-rows-8 lg:grid-cols-5 md:grid-cols-7 bg-white rounded-lg">
            <div class="col-span-1 lg:col-span-3 md:col-span-4 p-6">
                <h1 class="font-semibold text-gray-700 text-2xl">
                    Weclome Back, {{ user.first_name }}!
                </h1>
                <div class="mt-2">
                    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                        <div class="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 shadow sm:p-6">
                        <dt class="truncate text-sm font-medium text-gray-500">Daily Active Users</dt>
                            <dd v-if="isLoading" class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                            </dd>
                            <dd v-else class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="flex items-baseline text-2xl font-semibold text-gray-700">
                                    {{ data.active_users.daily_active_users.yesterday }}
                                </div>
                                <div v-if="data.active_users.daily_active_users.yesterday >= data.active_users.daily_active_users.previous_day" class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                                    <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-green-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="sr-only"> Increased by </span>
                                    {{ getDiffPercentage(data.active_users.daily_active_users.yesterday, data.active_users.daily_active_users.previous_day) }} %
                                </div>
                                <div v-else class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                                    <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="sr-only"> Decreased by </span>
                                    {{ getDiffPercentage(data.active_users.daily_active_users.previous_day, data.active_users.daily_active_users.yesterday) }} %
                                </div>
                            </dd>
                        </div>
                        <div class="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 shadow sm:p-6">
                        <dt class="truncate text-sm font-medium text-gray-500">Weekly Active Users</dt>
                        <dd v-if="isLoading" class="mt-1 flex items-baseline justify-between md:block lg:flex">
                            <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                        </dd>
                        <dd v-else class="mt-1 flex items-baseline justify-between md:block lg:flex">
                            <div class="flex items-baseline text-2xl font-semibold text-gray-700">
                                {{ data.active_users.weekly_active_users.this_week }}
                            </div>
                            <div v-if="data.active_users.weekly_active_users.this_week >= data.active_users.weekly_active_users.last_week" class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                                <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-green-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clip-rule="evenodd" />
                                </svg>
                                <span class="sr-only"> Increased by </span>
                                {{ getDiffPercentage(data.active_users.weekly_active_users.this_week, data.active_users.weekly_active_users.last_week) }} %
                            </div>
                            <div v-else class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                                <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" clip-rule="evenodd" />
                                </svg>
                                <span class="sr-only"> Decreased by </span>
                                {{ getDiffPercentage(data.active_users.weekly_active_users.last_week, data.active_users.weekly_active_users.this_week) }} %
                            </div>
                        </dd>
                        </div>
                        <div class="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 shadow sm:p-6">
                        <dt class="truncate text-sm font-medium text-gray-500">Monthly Active Users</dt>
                            <dd v-if="isLoading" class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                            </dd>
                            <dd v-else class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="flex items-baseline text-2xl font-semibold text-gray-700">
                                    {{ data.active_users.monthly_active_users.this_month }}
                                </div>
                                <div v-if="data.active_users.monthly_active_users.this_month >= data.active_users.monthly_active_users.last_month" class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                                    <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-green-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="sr-only"> Increased by </span>
                                    {{ getDiffPercentage(data.active_users.monthly_active_users.this_month, data.active_users.monthly_active_users.last_month) }} %
                                </div>
                                <div v-else class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-xs font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0">
                                    <svg class="-ml-1 mr-0.5 h-4 w-4 flex-shrink-0 self-center text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" clip-rule="evenodd" />
                                    </svg>
                                    <span class="sr-only"> Decreased by </span>
                                    {{ getDiffPercentage(data.active_users.monthly_active_users.this_month, data.active_users.monthly_active_users.last_month) }} %
                                </div>
                            </dd>
                        </div>
                    </dl>
                </div>
                <div class="mt-2 rounded-lg shadow bg-gray-50">
                    <h1 class="font-semibold text-gray-700 text-xl p-4">
                        Monthly Active User Trend
                    </h1>
                    <div v-if="isLoading">
                        <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                    </div>
                    <apex-chart v-else type="area" height='200' width='100%' class="justify-end"
                        :options="{
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                gradient: {
                                    enabled: true,
                                    opacityFrom: 0.55,
                                    opacityTo: 0
                                }
                            },
                            stroke: {
                                curve: 'smooth',
                                width: 1.75,
                            },
                            xaxis: {
                                categories: Object.keys(data.active_user_series)
                            },
                            yaxis: {
                                labels: {
                                    show: false,
                                }
                            },
                            grid: {
                                show: false
                            }
                        }"
                        :series="[{
                            name: 'Monthly Active Users',
                            data: Object.values(data.active_user_series)
                        }]"
                    ></apex-chart>
                </div>
                <div class="mt-2 grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-2">
                    <div class="col-span-1 lg:col-span-2 md:col-span-2">
                        <div class="rounded-lg bg-gray-50 p-6 shadow">
                            <h1 class="font-semibold text-gray-700 text-xl p-4">
                                Monthly Recurring Users
                            </h1>
                            <div v-if="isLoading">
                                <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                            </div>
                            <apex-chart v-else type="bar" height='150' width='100%' class="justify-end"
                                :options="{
                                    chart: {
                                        toolbar: {
                                            show: false,
                                        }
                                    },
                                    plotOptions: {
                                        bar: {
                                            borderRadius: 10,
                                            columnWidth: '30%',
                                        }
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    stroke: {
                                        lineCap: 'round',
                                    },
                                    legend: {
                                        position: 'bottom',
                                        formatter: function(value) {
                                                var val = value
                                                if (val.length > 20) {
                                                    val = val.substring(0, 20)+'...'
                                                }
                                                return val
                                            } 
                                    },
                                    grid: {
                                        show: false,
                                    },
                                    xaxis:  {
                                        categories: Object.keys(data.recurring_users)
                                    }
                                }"
                                :series="[{
                                    name: 'Recurring Users',
                                    data: Object.values(data.recurring_users)
                                }]"
                            ></apex-chart>
                        </div>
                    </div>
                    <div class="col-span-1">
                        <div class="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 shadow sm:p-6 mt-3">
                        <dt class="truncate text-sm font-medium text-gray-500">New Users</dt>
                            <dd v-if="isLoading" class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                            </dd>
                            <dd v-else class="mt-1 flex items-baseline justify-between md:block lg:flex">
                                <div class="flex-wrap items-baseline text-2xl font-semibold text-gray-700">
                                    {{ data.new_users }}
                                    <apex-chart type="area" height='125' width='100%' class="justify-end"
                                        :options="{
                                            chart: {
                                                toolbar: {
                                                    show: false,
                                                }
                                            },
                                            dataLabels: {
                                                enabled: false
                                            },
                                            fill: {
                                                gradient: {
                                                    enabled: true,
                                                    opacityFrom: 0.55,
                                                    opacityTo: 0
                                                }
                                            },
                                            stroke: {
                                                curve: 'smooth',
                                                width: 1.25,
                                            },
                                            xaxis: {
                                                axisBorder: {
                                                    show: false
                                                },
                                                axisTicks: {
                                                    show: false
                                                },
                                                categories: Object.keys(data.new_user_series),
                                                labels: {
                                                    show: false,
                                                }
                                            },
                                            yaxis: {
                                                labels: {
                                                    show: false,
                                                }
                                            },
                                            grid: {
                                                show: false
                                            }
                                        }"
                                        :series="[{
                                            name: 'New Users',
                                            data: Object.values(data.new_user_series)
                                        }]"
                                    ></apex-chart>
                                </div>
                            </dd>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-1 lg:col-span-2 md:col-span-3">
                <div class="rounded-lg bg-gray-50 p-6 shadow mt-6 mx-2">
                    <h1 class="font-semibold text-gray-700 text-xl p-4">
                       User Type Breakdown
                    </h1>
                    <div v-if="isLoading">
                        <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                    </div>
                    <apex-chart v-else type="donut" height='230' width='100%' class="justify-end"
                        :options="{
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            },
                            plotOptions: {
                                pie: {
                                    donut: {
                                        size: '80%',
                                        labels: {
                                            show: true,
                                            value: {
                                                show: true
                                            },
                                            total: {
                                                show: true,
                                            
                                            }
                                        },
                                    }
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                lineCap: 'round',
                            },
                            legend: {
                                position: 'right',
                                formatter: function(value) {
                                        var val = value
                                        if (val.length > 20) {
                                            val = val.substring(0, 20)+'...'
                                        }
                                        return val
                                    } 
                            },
                            grid: {
                                show: false,
                            },
                            
                            labels: Object.keys(data.user_breakdown)
                        }"
                        :series="Object.values(data.user_breakdown)"
                    ></apex-chart>
                </div>
                <div class="rounded-lg bg-gray-50 p-6 shadow mt-2 mx-2">
                    <h1 class="font-semibold text-gray-700 text-xl p-4">
                       Module Usage 
                    </h1>
                    <div v-if="isLoading">
                        <div class="w-10 h-10 ease-linear border-4 border-t-4 border-gray-200 border-top-rounded-full loader"></div>
                    </div>
                    <apex-chart v-else type="bar" height='250' width='100%' class="justify-end"
                        :options="{
                            chart: {
                                toolbar: {
                                    show: false,
                                }
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 10,
                                    columnWidth: '30%',
                                }
                            },
                            dataLabels: {
                                enabled: false
                            },
                            stroke: {
                                lineCap: 'round',
                            },
                            legend: {
                                position: 'bottom',
                                formatter: function(value) {
                                        var val = value
                                        if (val.length > 20) {
                                            val = val.substring(0, 20)+'...'
                                        }
                                        return val
                                    } 
                            },
                            grid: {
                                show: false,
                            },
                            xaxis:  {
                                categories: Object.keys(data.module_breakdown)
                            }
                        }"
                        :series="[{
                            name: 'Module Usage',
                            data: Object.values(data.module_breakdown)
                        }]"
                    ></apex-chart>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    props: {
       user: {
        type: [Array, Object],
        required: true,
       },
       dataRoute: {
        type: String,
        required: true
       }
    },

    data () {
        return {
            data: {},
            isLoading: true,
        }
    },

    created() {
        this.loadDashboardData();
    },

    computed: {
        seriesLabels() {
            return this.data.active_user_series.keys()
        }
    },

    methods: {
        async loadDashboardData() {
            try {
                this.isLoading = true;
                const response = await axios.get(this.dataRoute);
                this.data = response.data;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
                return false;
            }

            return true;
        },

        getDiffPercentage(big_num, small_num) {
            var delta = big_num - small_num;
            return Math.round((((delta/big_num) * 100) + Number.EPSILON) * 100) / 100;
        }
    },
};
</script>